import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userRole: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setUserRole: (state, action) => {
      const { userRole } = action.payload;
      state.userRole = userRole;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRole.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchUserRole.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchUserRole.fulfilled, (state, action) => {
        state.status = "loaded";
        state.userRole = action.payload;
      });
  },
});

export const fetchUserRole = createAsyncThunk(
  "operations/fetchUserRole",
  async () => {
    const response = await axios.get(`/account/user-profile`);
    return response.data.Role;
  },
);

export const selectUserRole = (state) => state.sessionInfo.user.userRole;

export default userSlice.reducer;
